'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _WebIndex = require('./WebIndex');

var _WebIndex2 = _interopRequireDefault(_WebIndex);

var _H5Index = require('./H5Index');

var _H5Index2 = _interopRequireDefault(_H5Index);

var _Locale = require('./lang/Locale');

var _Locale2 = _interopRequireDefault(_Locale);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var App = function (_React$Component) {
    _inherits(App, _React$Component);

    function App() {
        _classCallCheck(this, App);

        return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
    }

    _createClass(App, [{
        key: 'componentWillMount',
        value: function componentWillMount() {

            var search = new URLSearchParams(location.search);

            // 语言设置
            var paramLang = search.get("lang");
            if (null == paramLang || paramLang.length === 0) {
                //paramLang = "chs";
            }
            _Locale2["default"].GetInstance().InitLang(paramLang, navigator.language || navigator.userLanguage);
        }
    }, {
        key: 'render',
        value: function render() {

            var u = navigator.userAgent;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
            var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

            if (isAndroid || isiOS) {
                return _react2["default"].createElement(_H5Index2["default"], null);
            } else {
                return _react2["default"].createElement(_WebIndex2["default"], null);
            }
        }
    }]);

    return App;
}(_react2["default"].Component);

exports["default"] = App;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./App.js
// module id = 261
// module chunks = 0